import React, { useState, useEffect } from 'react';
import { Routes, Route, Link, useLocation, useNavigate } from 'react-router-dom';

import { Card, CardHeader } from '../components/Card';
import { SpendingList, SpendingListItem } from '../components/SpendingList';

import { SVGHome, SVGMoneyNote } from '../components/SVG';

export default function Spending({numberValue}) {
    return (
        <div className='flex flex-col relative px-3 gap-3 body-spacing'>
            <Card>
                <CardHeader heading='October 2024 (This month)' />
                <SpendingList>
                    <SpendingListItem label='Food' description={'Lorem ipsum dolor sit amet. Morbi sagittis fermentum lorem in rutrum.'} value={'£20.00'} />
                    <SpendingListItem label='Savings' value={'£150.00'} />
                    <SpendingListItem label='Debt repayment' description={'Lorem ipsum dolor sit amet. Morbi sagittis fermentum lorem in rutrum.'} value={'£300.00'} />
                </SpendingList>
            </Card>
            <Card>
                <CardHeader heading='September 2024' />
                <SpendingList>
                    <SpendingListItem label='Food' description={'Lorem ipsum dolor sit amet. Morbi sagittis fermentum lorem in rutrum.'} value={'£20.00'} />
                    <SpendingListItem label='Savings' value={'£150.00'} />
                    <SpendingListItem label='Debt repayment' description={'Lorem ipsum dolor sit amet. Morbi sagittis fermentum lorem in rutrum.'} value={'£300.00'} />
                </SpendingList>
            </Card>
            <Card>
                <CardHeader heading='August 2024' />
                <SpendingList>
                    <SpendingListItem label='Food' description={'Lorem ipsum dolor sit amet. Morbi sagittis fermentum lorem in rutrum.'} value={'£20.00'} />
                    <SpendingListItem label='Savings' value={'£150.00'} />
                    <SpendingListItem label='Debt repayment' description={'Lorem ipsum dolor sit amet. Morbi sagittis fermentum lorem in rutrum.'} value={'£300.00'} />
                </SpendingList>
            </Card>
            <Card>
                <CardHeader heading='July 2024' />
                <SpendingList>
                    <SpendingListItem label='Food' description={'Lorem ipsum dolor sit amet. Morbi sagittis fermentum lorem in rutrum.'} value={'£20.00'} />
                    <SpendingListItem label='Savings' value={'£150.00'} />
                    <SpendingListItem label='Debt repayment' description={'Lorem ipsum dolor sit amet. Morbi sagittis fermentum lorem in rutrum.'} value={'£300.00'} />
                </SpendingList>
            </Card>
            <Card>
                <CardHeader heading='June 2024' />
                <SpendingList>
                    <SpendingListItem label='Food' description={'Lorem ipsum dolor sit amet. Morbi sagittis fermentum lorem in rutrum.'} value={'£20.00'} />
                    <SpendingListItem label='Savings' value={'£150.00'} />
                    <SpendingListItem label='Debt repayment' description={'Lorem ipsum dolor sit amet. Morbi sagittis fermentum lorem in rutrum.'} value={'£300.00'} />
                </SpendingList>
            </Card>
        </div>
    );
}